import BaseService from "./BaseService";
import { mapStatus } from "../constants/status";

export default class MapService extends BaseService {
  constructor() {
    super();
  }

  async get() {
    if (window.redseats == undefined) {
      let html = document.getElementById("root");
      html.innerHTML = `<p>Not authorized</p>`;
      return;
    }

    if (window.redseats.mapKey) {
      const result = await super.callApi(
        `map/${window.redseats.mapKey}`,
        "Get"
      );
      if (result.statusCode == "200") {
        result.data.name = window.redseats.mapName ?? "default";
        result.data.categories = window.redseats.categories;
        return result.data;
      } else return super.htmlError(result.errorMessage);
    }

    return {
      name: window.redseats.mapName ?? "default",
      categories: window.redseats.categories,
      status: mapStatus.new,
      isPublished: false,
    };
  }

  async getById(mapId : string) {
    const result = await super.callApi(
      `map/${mapId}`,
      "Get"
    );
    if (result.statusCode == "200") {
      return result.data;
    } else return super.htmlError(result.errorMessage);
  }

  async create(data: any) {
    const result = await super.callApi("map", "Post", data);
    return result;
  }

  async updateData(data: any) {
    const result = await super.callApi("map", "Put", {
      key: data.key,
      name: data.name,
      categories: data.categories,
    });
    return result;
  }

  async updateLayout(formData: any) {
    const result = await super.callApi("map/layout", "Put", formData, { 'Content-Type': 'multipart/form-data' });
    return result;
  }

  async publish({ key, imageUrl }: { key: string; imageUrl: string }) {
    const result = await super.callApi("map/publish", "Put", {
      key,
      imagebase64: imageUrl
    });
    return result;
  }

  async getPublishedMaps() {
    const result = await super.callApi("map/published", "Get");
    if (result.statusCode == "200") {
      return result.data;
    } else return super.htmlError(result.errorMessage);
  }
}
